import { performGetRequest } from '@atlassian/jira-fetch';
import type { SkipApplicationPropertyType } from './types';

export const getOnboardingSkipApplicationProperty = (): Promise<SkipApplicationPropertyType> =>
	performGetRequest('/rest/onboarding/1.0/skip');
